<!--
  ~ Copyright (C) 2023 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->

<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner"></div>
</div>
